export default (arr, by, render = (item) => item) =>
  arr.reduce(
    (mapping, item, idx) => ({
      ...mapping,
      [item[by]]: render(item, idx)
    }),
    {}
  )
